// Multi-Select Add-to-Cart Banner Logic
(function() {
  // Helper to get all checkboxes in product cards
  function getProductCheckboxes() {
    return Array.from(document.querySelectorAll('.product-card-wrapper input[type="checkbox"][data-product-id]'));
  }

  // Show/hide banner and update count
  function updateBanner() {
    const checkboxes = getProductCheckboxes();
    const selected = checkboxes.filter(cb => cb.checked);
    const banner = document.getElementById('multi-add-banner');
    if (selected.length > 0) {
      banner.style.display = 'flex';
    } else {
      banner.style.display = 'none';
    }
  }

  // Add to cart AJAX for all selected products
  function addSelectedToCart() {
    const checkboxes = getProductCheckboxes();
    const selected = checkboxes.filter(cb => cb.checked);
    if (selected.length === 0) return;
    const items = selected.map(cb => ({
      id: cb.getAttribute('data-variant-id') || cb.getAttribute('data-product-id'),
      quantity: 1
    }));
    // Shopify AJAX cart API expects variant IDs
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(async data => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        // Fetch the latest cart drawer HTML
        const sectionsRes = await fetch('/?sections=cart-drawer');
        const sectionsData = await sectionsRes.json();
        const parsedState = {
          sections: {
            'cart-drawer': sectionsData['cart-drawer']
          }
        };
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(parsedState);
        }
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      } else {
        window.location.href = '/cart';
      }
      // --- RESET CHECKBOXES ---
      checkboxes.forEach(cb => { cb.checked = false; });
      updateBanner();
    })
    .catch(err => {
      alert('Could not add products to cart.');
      console.error(err);
    });
  }

  // Attach event listeners
  document.addEventListener('change', function(e) {
    if (e.target.matches('.product-card-wrapper input[type="checkbox"][data-product-id]')) {
      updateBanner();
    }
  });
  document.getElementById('multi-add-to-cart').addEventListener('click', function(e) {
    e.preventDefault();
    addSelectedToCart();
  });

  // Initialize (in case of pre-checked)
  updateBanner();
})();
